var N = Object.defineProperty;
var r = (i, e, R) => e in i ? N(i, e, { enumerable: !0, configurable: !0, writable: !0, value: R }) : i[e] = R;
var _ = (i, e, R) => r(i, typeof e != "symbol" ? e + "" : e, R);
import { jsx as A } from "react/jsx-runtime";
import { createContext as g } from "react";
import { createClient as T, createConfig as n } from "@hey-api/client-fetch";
import { AppConfigKey as t } from "./chunk367.js";
import { DEFAULT_APP_CONFIG as E } from "./chunk368.js";
class O {
  constructor() {
    _(this, "_appConfig", {});
    _(this, "_clientConfig", {
      fetch: (e) => fetch(e, { credentials: "include" })
    });
    _(this, "_clientGateway", T(n(this._clientConfig)));
    _(this, "_clientB2G", T(n(this._clientConfig)));
    _(this, "_clientApiSurvey", T(n(this._clientConfig)));
    _(this, "_clientApiFront", T(n(this._clientConfig)));
    _(this, "_clientIdentity", T(n(this._clientConfig)));
    _(this, "setClientConfigs", () => {
      this._clientGateway.setConfig({
        ...this._clientConfig,
        baseUrl: this.getValue(t.BACKEND_GATEWAY_DOMAIN) ?? E.BACKEND_GATEWAY_DOMAIN
      }), this._clientB2G.setConfig({
        ...this._clientConfig,
        baseUrl: this.getValue(t.BACKEND_B2G_DOMAIN) ?? E.BACKEND_B2G_DOMAIN
      }), this._clientApiSurvey.setConfig({
        ...this._clientConfig,
        baseUrl: this.getValue(t.BACKEND_API_SURVEY_DOMAIN) ?? E.BACKEND_API_SURVEY_DOMAIN
      }), this._clientApiFront.setConfig({
        ...this._clientConfig,
        baseUrl: this.getValue(t.BACKEND_FRONTEND_DOMAIN) ?? E.BACKEND_FRONTEND_DOMAIN
      }), this._clientIdentity.setConfig({
        ...this._clientConfig,
        baseUrl: this.getValue(t.BACKEND_IDENTITY_DOMAIN) ?? E.BACKEND_IDENTITY_DOMAIN
      });
    });
  }
  get appConfig() {
    return this._appConfig;
  }
  get WITHOUT_PROFILUM_BRAND() {
    return this.getValue(t.WITHOUT_PROFILUM_BRAND) === "true";
  }
  get IS_LNR() {
    return this.getValue(t.IS_LNR) === "true";
  }
  get YANDEX_METRIC_ID() {
    return Number(this.getValue(t.YANDEX_METRIC_ID)) || E.YANDEX_METRIC_ID;
  }
  get YANDEX_METRIC_ENABLED() {
    return this.getValue(t.YANDEX_METRIC_ENABLED) === "true";
  }
  get B2GNEW_REMOTE_ENTRY() {
    return this.getValue(t.B2GNEW_REMOTE_ENTRY) ?? E.B2GNEW_REMOTE_ENTRY;
  }
  get CLASSES_REMOTE_ENTRY() {
    return this.getValue(t.CLASSES_REMOTE_ENTRY) ?? E.CLASSES_REMOTE_ENTRY;
  }
  get LESSONS_REMOTE_ENTRY() {
    return this.getValue(t.LESSONS_REMOTE_ENTRY) ?? E.LESSONS_REMOTE_ENTRY;
  }
  get MATERIALS_REMOTE_ENTRY() {
    return this.getValue(t.MATERIALS_REMOTE_ENTRY) ?? E.MATERIALS_REMOTE_ENTRY;
  }
  get PARENTMAIN_REMOTE_ENTRY() {
    return this.getValue(t.PARENTMAIN_REMOTE_ENTRY) ?? E.PARENTMAIN_REMOTE_ENTRY;
  }
  get RESULTS_REMOTE_ENTRY() {
    return this.getValue(t.RESULTS_REMOTE_ENTRY) ?? E.RESULTS_REMOTE_ENTRY;
  }
  get STATISTICS_REMOTE_ENTRY() {
    return this.getValue(t.STATISTICS_REMOTE_ENTRY) ?? E.STATISTICS_REMOTE_ENTRY;
  }
  get PROFESSIONS_REMOTE_ENTRY() {
    return this.getValue(t.PROFESSIONS_REMOTE_ENTRY) ?? E.PROFESSIONS_REMOTE_ENTRY;
  }
  get SURVEY_REMOTE_ENTRY() {
    return this.getValue(t.SURVEY_REMOTE_ENTRY) ?? E.SURVEY_REMOTE_ENTRY;
  }
  get USER_EXPERIENCE_REMOTE_ENTRY() {
    return this.getValue(t.USER_EXPERIENCE_REMOTE_ENTRY) ?? E.USER_EXPERIENCE_REMOTE_ENTRY;
  }
  get LOGIN_AND_REGISTRATION_REMOTE_ENTRY() {
    return this.getValue(t.LOGIN_AND_REGISTRATION_REMOTE_ENTRY) ?? E.LOGIN_AND_REGISTRATION_REMOTE_ENTRY;
  }
  get HOST_REMOTE_ENTRY() {
    return this.getValue(t.HOST_REMOTE_ENTRY) ?? E.HOST_REMOTE_ENTRY;
  }
  get API_SURVEY_IMAGE_URL() {
    return this.getValue(t.API_SURVEY_IMAGE_URL) ?? E.API_SURVEY_IMAGE_URL;
  }
  get S3_URL() {
    return this.getValue(t.S3_URL) ?? E.S3_URL;
  }
  get clientGateway() {
    return this._clientGateway;
  }
  get clientB2G() {
    return this._clientB2G;
  }
  get clientApiSurvey() {
    return this._clientApiSurvey;
  }
  get clientApiFront() {
    return this._clientApiFront;
  }
  get clientIdentity() {
    return this._clientIdentity;
  }
  setValue(e, R) {
    this._appConfig[e] = R;
  }
  getValue(e) {
    return this._appConfig[e];
  }
}
const S = new O(), I = g(S), a = ({ children: i, config: e }) => /* @__PURE__ */ A(I, { value: e, children: i });
export {
  I as AppConfigContext,
  a as AppConfigProvider,
  S as appConfig
};
